import React, { useState } from 'react';

import { useGetMatterCompanionsQuery } from '@/services/api/mattersService';

import { ManageCompanionsModal } from './ManageCompanionsModal';

interface CompanionsBannerProps {
  matterId?: string;
}

export const CompanionsBanner: React.FC<CompanionsBannerProps> = ({
  matterId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: companions, error } = useGetMatterCompanionsQuery(
    matterId || '',
    {
      skip: !matterId,
    },
  );

  const isCurrentPrimary = companions?.members.some(
    (m) => m.is_primary && m.id === matterId,
  );

  const memberCount = companions?.members.length ?? 0;
  const hasMultipleMembers = memberCount > 1;

  // Show banner if:
  // 1. There are multiple members in the group, OR
  // 2. This case is the primary (even if it's the only member - prompts user to add companions)
  const shouldShowBanner =
    !error && companions && (hasMultipleMembers || isCurrentPrimary);

  if (!shouldShowBanner) return null;

  const caseText = memberCount === 1 ? 'case' : 'cases';

  return (
    <>
      <div className="px-4 py-2 bg-blue-50 border border-blue-200">
        <div className="flex items-center gap-2 text-sm text-blue-900">
          {hasMultipleMembers ? (
            <>
              <button
                type="button"
                className="font-medium hover:text-blue-700 hover:underline cursor-pointer text-left"
                onClick={() => setIsModalOpen(true)}
              >
                {memberCount} related {caseText}
              </button>
              {isCurrentPrimary && (
                <>
                  <span className="text-blue-700">•</span>
                  <span className="font-medium">Primary case</span>
                </>
              )}
            </>
          ) : (
            <>
              <span className="font-medium">Primary case</span>
              <span className="text-blue-700">•</span>
              <button
                type="button"
                className="hover:text-blue-700 hover:underline cursor-pointer"
                onClick={() => setIsModalOpen(true)}
              >
                Link companion cases
              </button>
            </>
          )}
        </div>
      </div>

      {matterId && (
        <ManageCompanionsModal
          matterId={matterId}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default CompanionsBanner;
